import React from 'react';

const OtherReason = props => {
  const { otherReason, handleChange } = props;
  return (
    <input
      className="form-control"
      name="otherReason"
      placeholder="Please tell us why"
      onChange={handleChange}
      value={otherReason}
    />
  );
};

export default OtherReason;



// WEBPACK FOOTER //
// ./src/pages/student/OnBoard/LanguageProfile/OtherReason/index.js